import React, { useState, useRef, useEffect } from 'react';
import './ResultCardPopUp.css';
import CopyIcon from '../../assets/icons/copy_icon.svg';
import CheckIcon from '../../assets/icons/check_icon.svg';
import GeneralTooltip from '../common/GeneralTooltip.js';

function ExtractSnippet({ 
  content, 
  getSnippet, 
  collapsedHeight = '200px',
  expandedMinHeight = '200px'
}) {
  const [analysisExpanded, setAnalysisExpanded] = useState(false);
  const [copiedSection, setCopiedSection] = useState(null);
  const [showMoreVisible, setShowMoreVisible] = useState(false);
  const containerRef = useRef(null);
  const textRef = useRef(null);
  const [copyStatus, setCopyStatus] = useState({});

  const copyToClipboard = (text, section) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        setCopiedSection(section);
        setCopyStatus({ copied: true, time: Date.now() });
        setTimeout(() => setCopiedSection(null), 2000);
        setTimeout(() => setCopyStatus({}), 2000);
      })
      .catch(() => {});
  };

  useEffect(() => {
    const checkOverflow = () => {
      if (containerRef.current && textRef.current) {
        const isOverflowing = textRef.current.scrollHeight > containerRef.current.clientHeight;
        setShowMoreVisible(isOverflowing);
      }
    };

    checkOverflow();
    const resizeObserver = new ResizeObserver(checkOverflow);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [content, analysisExpanded]);

  return (
    <>
      <div className='results-keyword-section-header'>
        <h3 className='results-keyword-section-title'>Extract</h3>
        <GeneralTooltip
          content={<div style={{ padding: '4px' }}>{copyStatus.copied ? 'Copied!' : 'Copy extract'}</div>}
          position='top'
          delay={100}
          verticalOffset={4}
          triggerClassName='copy-keywords-button results'
        >
          <button 
            onClick={(e) => { e.stopPropagation(); copyToClipboard(content, 'extract'); }}
            className='copy-keywords-button results'
          >
            <img src={copiedSection === 'extract' ? CheckIcon : CopyIcon} alt={copiedSection === 'extract' ? 'Copied!' : 'Copy keywords'} />
          </button>
        </GeneralTooltip>
      </div>
      
      <div 
        className={`analysis-container ${analysisExpanded ? 'expanded' : 'collapsed'}`}
        ref={containerRef}
        style={{ '--collapsed-height': collapsedHeight, '--expanded-min-height': expandedMinHeight }}
      >
        <pre className='detailed-analysis' ref={textRef}>{content}</pre>
        {showMoreVisible && !analysisExpanded && (
          <div className='show-more-overlay'>
            <button className='show-more-button' onClick={(e) => { e.stopPropagation(); setAnalysisExpanded(true); }}>
              ...<strong>Show More</strong>
            </button>
          </div>
        )}
        {analysisExpanded && (
          <button className='show-less-button' onClick={(e) => { e.stopPropagation(); setAnalysisExpanded(false); }}>
            <strong>Show Less</strong>
          </button>
        )}
      </div>
    </>
  );
}

export default ExtractSnippet;


